import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
// 引入转译方法
import { fun_DownloadFile, deepCopy } from "@/utils/validate";
import { Loading } from "element-ui";
import CaLock from "@/components/common/calock";
// 引入历史核验页面
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
// 引入公告项目选中页面
import TenderNotice from "../../components/prequalificationChoose/index.vue";
// 引入附件上传页面
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
// 引入资格预审结果备份详情页面
import PrequalificationBackup from "../../components/prequalificationBackupChoose/index.vue";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
        tenderPrjName: null, // 招标项目名称
        prequalificationStartDate: null, // 预审公示开始时间
        prequalificationEndDate: null, // 预审公示结束时间
        drawTime: null, // 随机抽签时间
        drawAddress: null, // 随机抽签地点
        publishFlag: "0", // 是否网上公布
        prequalificationCondition: null, // 资格预审情况
        remarks: null, // 备注
        municipalScale: null, // 工程规模指标
        quotaNum: null, // 合格投标人数量
        unitProjectNum: null, // 单位工程数（个）
        reviewAdd: null, // 评审地点
        reviewDate: null, // 评审时间
        prequalificationContent: null, // 评审程序和内容
        state: null, // 状态
        stateName: null, // 状态名称
        auditState: null, // 核验状态
        auditStateName: null, // 核验状态名称
        reportState: null, // 报告状态
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        /**********************文件下载名单字段***************************/
        isSemifinalist: null, // 预审结果
        reason: null, // 不合格/未入围原因
        /**********************资格预审信息***************************/
        section: null, // 标段
        tenderReference: null, // 招标编号
        noticeReplyDays: null, // 通知书回复天数（天）
        noticeIssueDate: null, // 通知书发出时间
        noticeReplyEndDate: null, // 通知书回复截止时间
        preResultExplainEndDate: null // 资格预审结果解释截止时间
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
        tenderPrjName: null, // 招标项目名称
        prequalificationStartDate: null, // 预审公示开始时间
        prequalificationEndDate: null, // 预审公示结束时间
        drawTime: null, // 随机抽签时间
        drawAddress: null, // 随机抽签地点
        publishFlag: null, // 是否网上公布
        prequalificationCondition: null, // 资格预审情况
        remarks: null, // 备注
        municipalScale: null, // 工程规模指标
        quotaNum: null, // 合格投标人数量
        unitProjectNum: null, // 单位工程数（个）
        reviewAdd: null, // 评审地点
        reviewDate: null, // 评审时间
        prequalificationContent: null, // 评审程序和内容
        state: null, // 状态
        stateName: null, // 状态名称
        auditState: null, // 核验状态
        auditStateName: null, // 核验状态名称
        reportState: null, // 报告状态
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        /**********************资格预审信息***************************/
        section: null, // 标段
        tenderReference: null, // 招标编号
        noticeReplyDays: null, // 通知书回复天数（天）
        noticeIssueDate: null, // 通知书发出时间
        noticeReplyEndDate: null, // 通知书回复截止时间
        preResultExplainEndDate: null, // 资格预审结果解释截止时间
        /**********************撤回信息***************************/
        uploadFile: null // 撤回附件
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: this.$route.query.type, // 操作标志
      id: this.$route.query.id, // 主键
      isTenderSignature: this.$route.query.isTenderSignature, // 是否甲方确认
      decodeFlag: null, // 解密标志
      fileUrl: null, // 资格预审合格通知书下载路径
      resultFileUrl: null, // 资格预审结果通知书下载路径
      dialogMessage: null, // 倒计时弹框提示
      /************************甲方确认使用**************************/
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      /*****************************文件下载名单****************************/
      projectTenderLoading: false, // 列表loading状态
      // 查询表单字段
      projectTenderForm: {
        tenderUnitsName: null // 投标单位名称
      },
      // 查询表单
      projectTenderFormSearchList: [
        {
          type: "input",
          label: "投标单位名称：",
          value: "tenderUnitsName",
          placeholder: "请输入"
        }
      ],
      // 表格基础数据
      projectTenderTableColumns: [
        {
          label: "投标单位名称",
          slotName: "tenderUnitsName",
          minWidth: "300",
          fixed: true
        },
        {
          label: "资格预审申请文件下载",
          prop: "signUpTime",
          minWidth: "190"
        },
        {
          label: "已投标段",
          slotName: "bidSection",
          minWidth: "120"
        },
        {
          label: "预审结果",
          slotName: "isSemifinalist",
          minWidth: "120"
        },
        {
          label: "预审不通过原因",
          prop: "notSemifinalistReason",
          minWidth: "150"
        },
        {
          label: "回复状态",
          slotName: "replyState",
          minWidth: "150"
        },
        {
          label: "回复时间",
          prop: "replyDate",
          minWidth: "150"
        },
      ],
      // 表格数据
      projectTenderTableData: [],
      projectTenderMultipleSelection: [], // 勾选数组
      /*****************************资格预审评审小组成员名单****************************/
      memberLoading: false, // 列表loading状态
      // 表格基础数据
      memberTableColumns: [
        {
          label: "姓名",
          prop: "name"
        },
        {
          label: "工作单位",
          prop: "company"
        },
        {
          label: "职称",
          prop: "title"
        },
        {
          label: "职务",
          prop: "duty"
        },
        {
          label: "专业工作年限",
          prop: "takeJobDate"
        },
        {
          label: "在小组中担任的工作",
          prop: "workAs"
        },
        {
          label: "标段",
          prop: "section"
        }
      ],
      // 表格数据
      memberTableData: [],
      memberMultipleSelection: [], // 勾选数组
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      /*****************************资格预审信息****************************/
      preLoading: false, // 列表loading状态
      // 表头按钮组
      preBtnList: [
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 查询表单字段
      preForm: {
        section: null, // 标段
        tenderReference: null, // 招标编号
        noticeReplyDays: null, // 通知书回复天数（天）
        noticeIssueDate: null, // 通知书发出时间
        noticeReplyEndDate: null, // 通知书回复截止时间
        preResultExplainEndDate: null // 资格预审结果解释截止时间
      },
      // 表格基础数据
      preTableColumns: [
        {
          label: "标段",
          prop: "section"
        },
        {
          label: "通知书回复天数（天）",
          prop: "noticeReplyDays"
        },
        {
          label: "通知书发出时间",
          prop: "noticeIssueDate"
        },
        {
          label: "通知书回复截止时间",
          prop: "noticeReplyEndDate"
        },
        {
          label: "资格预审结果解释截止时间",
          prop: "preResultExplainEndDate"
        }
      ],
      // 表格数据
      preTableData: [],
      preMultipleSelection: [], // 勾选数组
      sections: [], // 标段数组
      /*****************************撤回信息****************************/
      controllerBackupFlg: null, // 操作标志
      backupLoading: false, // 列表loading状态
      // 查询表单字段
      backupForm: {},
      // 分页
      backupReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      backupTotal: 0, // 总条数
      // 表格基础数据
      backupTableColumns: [
        {
          label: "招标项目名称",
          prop: "tenderPrjName",
          isShow: true
        },
        {
          label: "撤回次数",
          prop: "revocationNum"
        },
        {
          label: "撤回原因",
          prop: "revocationReason"
        },
        {
          label: "撤回时间",
          prop: "backupDate"
        },
        {
          label: "操作",
          slotName: "operation"
        }
      ],
      // 表格数据
      backupTableData: [],
      // 用于判断状态图片
      flagState: null
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    TenderNotice, // 招标公告选择
    TenderPictureinfor, // 附件页面
    PrequalificationBackup, // 资格预审结果备份详情页面
    AuditHistoryRecord // 核验记录
  },
  // 模板编译完成
  mounted() {
    // 获取详情信息
    this.fun_Details();
    // 如果是详情或者撤回
    if (this.controllerFlg == "details" || this.controllerFlg == "revoke") {
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 资格预审合格通知书模板路径
    this.fun_GetFileUrl();
    // 资格预审结果通知书模板路径
    this.fun_GetResultFileUrll();
    // 默认全部展开
    this.$refs.collapseForm.activeNames = this.formConfigList.map(item => {
      return item.name;
    });
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/prequalification/detail", {
        controllerFlg: this.controllerFlg, // 操作标志
        id: this.id, // 主键
        isTenderSignature: this.isTenderSignature // 是否甲方确认
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.model;
          // 获取状态用于判断显示图片
          this.flagState = data.model.state;
          // 设置解密标志
          this.decodeFlag = data.decodeFlag;
          // 投标下载名单设置
          this.fun_SetProjectTender();
          // 资格预审评审小组成员名单
          this.fun_PrequalifictionMember();
          // 标段下拉框查询
          this.fun_GetSectionSelect();
          // 设置资格预审信息
          this.fun_SetPrequalification();
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 评审程序录入样式
          this.fun_GetReport();
          // 资格预审结果撤回录入样式
          this.fun_GetRevokeInfo();
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 评审程序录入样式
     */
    fun_GetReport() {
      // 如果是新增或者修改
      if (this.controllerFlg == "insert" || this.controllerFlg == "update") {
        // 公示开始时间不为空时
        if (
          this.form.prequalificationStartDate != null &&
          this.form.prequalificationStartDate != ""
        ) {
          // 遍历
          this.formConfigList.map((value, index) => {
            // 资格预审信息或者资格预审情况
            if (
              value.title === "资格预审信息" ||
              value.title === "资格预审情况"
            ) {
              // 遍历
              this.formConfigList[index].formConfigList.map(j => {
                // 不可编辑
                j.disabled = true;
              });
            }
          });
        }
      }
    },
    /**
     * 招标公告项目选择
     */
    fun_GetTenderNotice(e) {
      // 如果是选择招标公告项目
      if (e == "open") {
        // 打开弹窗
        this.$refs.tenderNotice.dialogVisible = true;
        // 请求接口
        this.$refs.tenderNotice.fun_GetOpen();
      }
      // 如果是清空招标公告项目
      else {
        // 清空招标公告编号
        this.form.announcementId = "";
        // 清空招标登记编号
        this.form.registrationId = "";
        // 清空招标项目名称
        this.form.tenderPrjName = "";
      }
    },
    /**
     * 设置招标公告
     * @param e
     */
    fun_SetTenderNotice(e) {
      // 设置招标公告编号
      this.form.announcementId = e.id;
      // 设置招标登记编号
      this.form.registrationId = e.registrationId;
      // 设置招标项目名称
      this.form.tenderPrjName = e.tenderPrjName;
      // 请求，获取结果集
      fun_PostAction("/prequalification/getDecodeFlag", {
        id: e.id
      }).then(res => {
        // 解构res.data
        const { data } = res.data;
        // 设置解密标志
        this.decodeFlag = data.decodeFlag;
        // 投标下载名单设置
        this.fun_SetProjectTender();
      });
      // 标段下拉框查询
      this.fun_GetSectionSelect();
      // 设置资格预审信息
      this.fun_SetPrequalification();
    },
    /**
     * 投标下载名单设置
     */
    fun_SetProjectTender() {
      // 如果该公告所有项目全部解密完成
      if (this.decodeFlag == "1") {
        // 如果是新增或者修改
        if (this.controllerFlg == "insert" || this.controllerFlg == "update") {
          // 公示开始时间不为空时
          if (
            this.form.prequalificationStartDate != null &&
            this.form.prequalificationStartDate != ""
          ) {
            // 添加文件下载名单
            this.formConfigList.splice(1, 0, {
              title: "",
              name: "3",
              icon: "",
              class: "downLoadList",
              formConfigList: [
                {
                  type: "slot",
                  slotName: "projectTenderList",
                  class: "formList"
                }
              ]
            });
          }
          // 公示开始时间为空时
          else {
            // 添加
            this.formConfigList.splice(1, 0, {
              title: "",
              name: "3",
              icon: "",
              class: "downLoadList",
              formConfigList: [
                {
                  label: "预审结果：",
                  type: "select",
                  value: "isSemifinalist",
                  width: "50%",
                  tip:
                    "请填写完“预审结果”、“预审不通过原因”等信息后，勾选投标单位，点击“确定”按钮，即可批量录入资格预审结果",
                  optionData: [
                    { name: "通过", value: "1" },
                    { name: "不通过", value: "0" }
                  ],
                  rule: {
                    required: false,
                    message: "请选择预审结果",
                    trigger: "blur"
                  }
                },
                {
                  label: "预审不通过原因：",
                  type: "slot",
                  slotName: "reason",
                  value: "reason",
                  width: "50%",
                  maxlength: 50,
                  disabled: true,
                  tip: "（50个汉字以内）",
                  rule: {
                    required: false,
                    message: "请填写预审不通过原因",
                    trigger: "blur"
                  }
                },
                {
                  type: "slot",
                  slotName: "projectTenderList",
                  class: "formList"
                }
              ]
            });
          }
        }
        // 如果是详情或者撤回
        else {
          // 添加
          this.formConfigList.splice(1, 0, {
            title: "",
            name: "3",
            icon: "",
            class: "downLoadList",
            formConfigList: [
              {
                type: "slot",
                slotName: "projectTenderList",
                class: "formList"
              }
            ]
          });
        }
        // 获取文件下载名单一览数据
        this.fun_ProjectTenderList();
      }
    },
    /**
     * 文件下载名单-确认按钮
     */
    fun_ProjectTenderBut() {
      debugger
      // 预审结果或入围结果为不合格的场合
      if (this.form.isSemifinalist == "0") {
        // 不合格原因为空的场合
        if (this.form.reason == "" || this.form.reason == null) {
          // 提示
          this.$message.error(
            "“预审结果”为“不通过”的场合，“预审不通过原因”必须填写！"
          );
          return false;
        }
      }
      // 判断是否勾选
      if (
        this.projectTenderMultipleSelection &&
        this.projectTenderMultipleSelection.length == 0
      ) {
        // 提示
        this.$message.error("请至少选中一行数据！");
        return false;
      }
      // 遍历数组数据
      this.projectTenderTableData.forEach((e, i) => {
        // 遍历勾选
        for (const index in this.projectTenderMultipleSelection) {
          // 判断是否勾选的主键
          if (e.id === this.projectTenderMultipleSelection[index].id) {
            // 设置表单预审结果
            this.projectTenderTableData[i].isSemifinalist = this.form.isSemifinalist;
            // 设置表单预审结果
            this.projectTenderTableData[i].drawResult = this.form.isSemifinalist;
            // 如果预审结果不合格
            if (this.form.isSemifinalist == "0") {
              // 设置预审结果不合格理由
              this.projectTenderTableData[i].notSemifinalistReason = this.form.reason;
            }
            // 如果预审结果合格
            else {
              // 清空预审结果不合格理由
              this.projectTenderTableData[i].notSemifinalistReason = "";
            }
          }
        }
      });
    },
    /**
     * 文件下载名单一览
     */
    fun_ProjectTenderList() {
      // 请求，获取结果集
      fun_PostAction("/prequalification/projectTenderList", {
        ...this.projectTenderForm,
        announcementId: this.form.announcementId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 判断
          if (data && data.length > 0) {
            // 遍历
            data.map(item => {
              // 不合格或不入围
              if (item.isSemifinalist === "0" || item.drawResult === "0") {
                // 不入围原因不为空
                if (item.notDrawReason) {
                  // 拼接预审结果不合格原因 + 不入围原因
                  item.notSemifinalistReason =
                    item.notSemifinalistReason + "," + item.notDrawReason;
                }
              }
            });
          }
          // 回显table
          this.projectTenderTableData = data;
        }
      });
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_ProjectTenderHandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.projectTenderMultipleSelection = e;
    },
    /**
     * 资格预审评审小组成员名单
     */
    fun_PrequalifictionMember() {
      // 如果是新增或者修改
      if (this.controllerFlg == "insert" || this.controllerFlg == "update") {
        // 公示开始时间不为空时
        if (
          this.form.prequalificationStartDate != null &&
          this.form.prequalificationStartDate != ""
        ) {
          // 设置表头
          this.memberBtnList = [
            {
              name: "添加",
              type: "success",
              icon: "circle-plus-outline"
            },
            {
              name: "删除",
              type: "danger",
              icon: "delete"
            }
          ];
        }
        // 公示开始时间为空时
        else {
          // 清空表头
          this.memberBtnList = [];
        }
      } else {
        // 清空表头
        this.memberBtnList = [];
      }
      // 资格预审评审小组成员名单一览
      this.fun_PrequalifictionMemberList();
    },
    /**
     * 资格预审评审小组成员名单一览
     */
    fun_PrequalifictionMemberList() {
      // 主键不为空时
      if (this.form.id != "" && this.form.id != null) {
        // 请求，获取结果集
        fun_PostAction("/prequalification/memberList", {
          prequalificationId: this.form.id,
          announcementId: this.form.announcementId
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 回显table
            this.memberTableData = data;
          }
        });
      }
    },
    /**
     * 资格预审评审小组成员名单表勾选事件
     * @params e 选中的数据
     */
    fun_MemberHandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.memberMultipleSelection = e;
    },
    /**
     * 获取标段数据
     */
    fun_GetSectionSelect() {
      // 请求，获取结果集
      fun_PostAction("/prequalification/sectionCombobox", {
        registrationId: this.form.registrationId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 标段下拉框
          this.sections = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 设置标段下拉框选中值
     * @param e
     */
    fun_GetSectionSelectVal(e) {
      // 设置标段号
      this.form.section = e.name;
      // 设置招标编号
      this.form.tenderReference = e.value;
    },
    /**
     * 设置资格预审信息
     */
    fun_SetPrequalification() {
      // 资格预审信息下标
      let i = 0;
      // 遍历
      this.formConfigList.map((element, index) => {
        // 匹配资格预审信息
        if (element.title === "资格预审信息") {
          // 下标赋值
          i = index;
        }
      });
      // 如果是新增或者修改
      if (this.controllerFlg == "insert" || this.controllerFlg == "update") {
        // 公示开始时间不为空时
        if (
          this.form.prequalificationStartDate != null &&
          this.form.prequalificationStartDate != ""
        ) {
          // 清空表头
          this.preBtnList = [];
          // 添加
          this.formConfigList[i].formConfigList.push({
            type: "slot",
            slotName: "preList",
            class: "formList"
          });
        }
        // 公示开始时间为空时
        else {
          // 添加
          this.formConfigList[i].formConfigList.push(
            {
              label: "标段：",
              type: "slot",
              slotName: "section",
              value: "section",
              width: "50%",
              rule: {
                required: false,
                message: "请选择标段",
                trigger: "blur"
              }
            },
            {
              label: "通知书回复天数（天）：",
              value: "noticeReplyDays",
              type: "number",
              disabled: false,
              required: true,
              maxlength: 2,
              rule: [
                {
                  required: false,
                  message: "请输入通知书回复天数（天）",
                  trigger: "blur"
                },
                {
                  pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                  message: "通知书回复天数（天）必须为数字"
                }
              ]
            },
            {
              label: "通知书发出时间：",
              type: "input",
              value: "noticeIssueDate",
              disabled: true
            },
            {
              label: "通知书回复截止时间：",
              type: "input",
              value: "noticeReplyEndDate",
              disabled: true
            },
            {
              label: "资格预审结果解释截止时间：",
              type: "slot",
              slotName: "preResultExplainEndDate",
              value: "preResultExplainEndDate",
              rule: {
                required: false,
                message: "请选择资格预审结果解释截止时间",
                trigger: "blur"
              }
            },
            {
              type: "slot",
              slotName: "preList",
              class: "formList"
            }
          );
        }
      }
      // 如果是详情或者撤回
      else {
        // 清空表头
        this.preBtnList = [];
        // 添加
        this.formConfigList[i].formConfigList.push({
          type: "slot",
          slotName: "preList",
          class: "formList"
        });
      }
      // 发送资格预审通知书信息一览
      this.fun_PrequalificationInfoList();
    },
    /**
     * 发送资格预审通知书信息一览
     */
    fun_PrequalificationInfoList() {
      // 请求，获取结果集
      fun_PostAction("/prequalification/infoList", {
        announcementId: this.form.announcementId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.preTableData = data;
        }
      });
    },
    /**
     * 资格预审信息确认
     */
    fun_PrequalificationBut() {
      // 清空错误消息
      this.errRules.section = "";
      // 清空错误消息
      this.errRules.noticeReplyDays = "";
      // 清空错误消息
      this.errRules.preResultExplainEndDate = "";
      // 错误消息数量
      let errNum = 0;
      // 如果标段信息为空
      if (this.form.section == "" || this.form.section == null) {
        // 返回错误消息
        this.errRules.section = "请选择标段！";
        errNum++;
      }
      // 标段信息不为空时
      else {
        // 遍历数组数据
        this.preTableData.forEach(e => {
          // 验证该标段是否重复
          if (e.section == this.form.section) {
            // 返回错误消息
            this.errRules.section = "选择的标段号重复，请重新选择！";
            errNum++;
          }
        });
      }
      // 如果通知书回复天数（天）为空
      if (
        this.form.noticeReplyDays == "" ||
        this.form.noticeReplyDays == null
      ) {
        // 返回错误消息
        this.errRules.noticeReplyDays = "请填写通知书回复天数（天）！";
        errNum++;
      }
      // 不为空时
      else {
        // 通知书回复天数（天）小于5
        if (this.form.noticeReplyDays < 5) {
          // 返回错误消息
          this.errRules.noticeReplyDays = "通知书回复天数应不小于5天！";
          errNum++;
        }
      }
      // 如果资格预审结果解释截止时间为空
      if (
        this.form.preResultExplainEndDate == "" ||
        this.form.preResultExplainEndDate == null
      ) {
        // 返回错误消息
        this.errRules.preResultExplainEndDate =
          "请选择资格预审结果解释截止时间！";
        errNum++;
      }
      // 错误数量大于0
      if (errNum > 0) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("您输入的数据存在错误！");
        return false;
      }
      // 设置标段号
      this.preForm.section = this.form.section;
      // 设置招标编号
      this.preForm.tenderReference = this.form.tenderReference;
      // 设置通知书回复天数（天）
      this.preForm.noticeReplyDays = this.form.noticeReplyDays;
      // 设置资格预审结果解释截止时间
      this.preForm.preResultExplainEndDate = this.form.preResultExplainEndDate;
      // 设置表单
      let form = this.preForm;
      // 添加表单
      this.preTableData = [...this.preTableData, { ...form }];
      // 清空标段号
      this.form.section = "";
      // 清空招标编号
      this.form.tenderReference = "";
      // 清空通知书回复天数（天）
      this.form.noticeReplyDays = "";
      // 清空资格预审结果解释截止时间
      this.form.preResultExplainEndDate = "";
      // 清空错误消息
      this.errRules.section = "";
      // 清空错误消息
      this.errRules.noticeReplyDays = "";
      // 清空错误消息
      this.errRules.preResultExplainEndDate = "";
    },
    /**
     * 资格预审信息删除
     */
    fun_PrequalificationDel() {
      // 判断是否勾选
      if (this.preMultipleSelection.length == 0) {
        this.$message.error("请至少选中一行数据！");
        return;
      }
      // 判断是否勾选
      if (this.preMultipleSelection && this.preMultipleSelection.length > 1) {
        this.$message.error("只能选择一行数据！");
        return;
      }
      // 设置下标
      let index = 0;
      // 遍历数组数据
      this.preTableData.forEach((e, i) => {
        // 验证该标段是否该标段
        if (e.tenderReference == this.preMultipleSelection[0].tenderReference) {
          // 获取下标
          index = i;
        }
      });
      // 询问框
      this.$confirm("确定删除这条数据嘛！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 将改对象直接从数组中替换
        this.preTableData.splice(index, 1);
      });
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_PreHandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.preMultipleSelection = e;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 如果是预审结果
      if (i == "isSemifinalist") {
        // 设置预审结果
        this.$set(this.form, "isSemifinalist", e);
        // 如果未合格或者未入围
        if (this.form.isSemifinalist == "0") {
          // 遍历
          this.formConfigList.map(element => {
            // 匹配文件下载名单
            if (element.name === "3") {
              // 遍历
              element.formConfigList.map(item => {
                // 匹配预审不通过原因
                if (item.value === "reason") {
                  // 取消置灰
                  item.disabled = false;
                }
              });
            }
          });
          // 已通过
        } else {
          // 清空不合格/未入围原因
          this.form.reason = "";
          // 遍历
          this.formConfigList.map(element => {
            // 匹配文件下载名单
            if (element.title === "3") {
              // 遍历
              element.formConfigList.map(item => {
                // 匹配预审不通过原因
                if (item.value === "reason") {
                  // 置灰
                  item.disabled = true;
                }
              });
            }
          });
        }
      } else {
        // 赋值
        this.form[i] = e;
      }
    },
    /**
     * 保存修改
     * @param e
     */
    fun_InsUpd(e) {
      // 设置状态
      this.form.state = e;
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果是保存
          if (e == "bc") {
            // 提交的方法
            this.fun_Submit();
          }
          // 如果是提交
          else {
            // 公示开始时间为空时
            if (
              this.form.prequalificationStartDate == null ||
              this.form.prequalificationStartDate == ""
            ) {
              // 请求，验证资格预审结果是否填写完整
              fun_PostAction("/prequalification/validateTender", {
                projectTenderList: JSON.stringify(this.projectTenderTableData),
                decodeFlag: this.decodeFlag
              }).then(res => {
                // 解构res.data
                const { result, msg } = res.data;
                // 判断请求是否成功
                if (result) {
                  // 如果是提交
                  if (e == "tj") {
                    // 开启弹窗
                    this.$refs.caLock.dialogCalock = true;
                    // 签名数据, 交易人名称和日期
                    this.$refs.caLock.data =
                      this.form.prjName + this.form.publishFlag;
                    // 状态
                    this.$refs.caLock.state = e;
                  } else {
                    // 提交的方法
                    this.fun_Submit();
                  }
                } else {
                  // 请求失败，弹出失败msg的消息提示
                  this.$message.error(msg);
                  return false;
                }
              });
            } else {
              // 开启弹窗
              this.$refs.caLock.dialogCalock = true;
              // 签名数据, 交易人名称和日期
              this.$refs.caLock.data =
                this.form.prjName +
                this.form.prequalificationStartDate +
                this.form.publishFlag;
              // 状态
              this.$refs.caLock.state = e;
            }
          }
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("您输入的数据存在错误！");
          return false;
        }
      });
    },
    /**
     * 撤回
     */
    fun_Revoke() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 开启弹窗
          this.$refs.caLock.dialogCalock = true;
          // 签名数据, 交易人名称和日期
          this.$refs.caLock.data =
            this.form.prjName +
            this.form.prequalificationStartDate +
            this.form.publishFlag;
          // 状态
          this.$refs.caLock.state = "tj";
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 不为空
      if (this.title != "" && this.title != null) {
        // 招标人提交
        this.fun_TenderStampSubmit();
      } else {
        // 如果是撤回页面
        if (this.controllerFlg == "revoke") {
          // 撤回的方法
          this.fun_RevokeSubmit();
        } else {
          // 确定的方法
          this.fun_Submit();
        }
      }
    },
    /**
     * 确定的方法
     */
    fun_Submit() {
      // 全局加载框
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      try {
        // 请求
        fun_PostAction("/prequalification/saveOrUpdate", {
          ...this.form, // form表单数据
          controllerFlg: this.controllerFlg, // 操作标志
          projectTenderList: JSON.stringify(this.projectTenderTableData), // 文件下载名单
          memberList: JSON.stringify(this.memberTableData), // 资格预审评审小组成员名单
          preList: JSON.stringify(this.preTableData) // 资格预审通知书信息
        }).then(res => {
          // 加载框取消
          this.fullLoading.close();
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.fun_Back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
          // 关闭loading
          this.loading = false;
        });
      } catch (e) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("操作失败！" + e);
        // 加载框取消
        this.fullLoading.close();
      }
    },
    // 资格预审撤回样式
    fun_GetRevokeInfo() {
      // 如果不是新增
      if (this.controllerFlg != "insert") {
        // 设置下标
        let index = 0;
        // 遍历
        this.formConfigList.map((e, j) => {
          // 资格预审评审信息
          if (e.title === "备注信息") {
            // 设置下标
            index = j;
          }
        });
        // 如果是撤回
        if (this.controllerFlg == "revoke") {
          // 添加
          this.formConfigList.splice(index + 1, 0, {
            title: "撤回信息",
            name: index + 1,
            icon: "",
            formConfigList: [
              {
                label: "附件上传：",
                value: "uploadFile",
                type: "slot",
                slotName: "uploadFile"
              },
              {
                label: "撤回理由：",
                value: "revocationReason",
                type: "textarea",
                width: "100%;",
                tip: "撤回资格预审结果需上传撤回附件与撤回理由。",
                required: true,
                maxlength: 1300,
                minRows: "3",
                maxRows: "2",
                rule: {
                  required: true,
                  message: "请填写撤回理由",
                  trigger: "blur"
                }
              },
              {
                label: "",
                type: "slot",
                slotName: "backupList",
                class: "formList",
                width: "100%;"
              }
            ]
          });
        }
        // 如果不是撤回
        else {
          // 添加
          this.formConfigList.splice(index + 1, 0, {
            title: "撤回信息",
            name: index + 1,
            icon: "",
            formConfigList: [
              {
                label: "",
                type: "slot",
                slotName: "backupList",
                class: "formList",
                width: "100%;"
              }
            ]
          });
        }
        // 清空页面显示撤回理由
        this.form.revocationReason = "";
        // 查询资格预审结果撤回一览
        this.fun_GetBackupList();
        // 默认全部展开
        this.$refs.collapseForm.activeNames = this.formConfigList.map(item => {
          return item.name;
        });
      }
    },
    // 查询资格预审结果撤回一览
    fun_GetBackupList() {
      // 请求，获取结果集
      fun_PostAction("/prequalificationBackup/list", {
        ...this.backupForm,
        ...this.backupReqPageData,
        announcementId: this.form.announcementId // 招标公告编号
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.backupTableData = records;
          // 获取分页总条数
          this.backupTotal = total;
        }
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_BackupLimitChange(e) {
      // 获取每页显示条数
      this.backupReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetBackupList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_BackupPageChange(e) {
      // 获取当前页码
      this.backupReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetBackupList();
    },
    // 查询资格预审结果撤回详情
    fun_GetBackupDetail(e) {
      // 打开弹窗
      this.$refs.prequalificationBackup.dialogVisible = true;
      // 关闭返回按钮
      this.$refs.prequalificationBackup.isBtn = false;
      // 设置数据编号
      this.$refs.prequalificationBackup.form.id = e.val.id;
      // 打开弹框时调用
      this.$refs.prequalificationBackup.fun_GetOpen();
    },
    // 查询资格预审结果撤回附件
    fun_GetBackupUpload(e, value) {
      // 如果是附件上传
      if (e == "update") {
        // 打开弹窗
        this.$refs.tenderPictureinfor.dialogVisible = true;
        // 设置数据编号
        this.$refs.tenderPictureinfor.form.recordNumber = this.form.id;
        // 打开弹框时调用
        this.$refs.tenderPictureinfor.fun_GetOpen();
      }
      // 如果是查看附件
      else {
        // 打开弹窗
        this.$refs.tenderPictureinfor.dialogVisible = true;
        // 设置数据编号
        this.$refs.tenderPictureinfor.form.recordNumber =
          value.prequalificationId;
        // 打开弹框时调用
        this.$refs.tenderPictureinfor.fun_GetOpen();
      }
    },
    /**
     * 撤回确认方法
     */
    fun_RevokeSubmit() {
      // 全局加载框
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      try {
        // 请求
        fun_PostAction("/prequalification/revokeInfo", {
          ...this.form // form表单数据
        }).then(res => {
          // 加载框取消
          this.fullLoading.close();
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.fun_Back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
          // 关闭loading
          this.loading = false;
        });
      } catch (e) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("操作失败！" + e);
        // 加载框取消
        this.fullLoading.close();
      }
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      this.form.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.table = data.model.tableName; // 表名
      this.tenderSignedForm.key = data.model.keyState; // 字段
      this.tenderSignedForm.recordNumber = data.model.id; // 数据编号
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId; // 招标人签章确认编号
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      this.tenderSignedForm.isDeregulation = data.isDeregulation; // 添加标记
      this.tenderSignedForm.esRegulators = data.esRegulators; // 招标人盖章确认的招标监管部门
      this.tenderSignedForm.esProcessType = data.esProcessType; // 招标人盖章确认的招标监管流程
      this.tenderSignedForm.esInvitationId = data.esInvitationId; // 招标人盖章确认权限编号
      this.tenderSignedForm.tenderStampData = data.tenderStampData; // 招标人盖章的数字签名
      //  招标人签章状态为提交，斌且状态等于1
      if (data.tenderSignedState == "tj" && data.isDeregulation != "1") {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 其他
          if (value.title === "其他") {
            // 遍历
            this.formConfigList[index].formConfigList.map(j => {
              // 如果是招标人意见
              if (j.value == "tenderOpinion") {
                // 可编辑
                j.disabled = false;
              }
            });
          }
        });
      } else {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 其他
          if (value.title === "其他") {
            // 遍历
            this.formConfigList[index].formConfigList.map(j => {
              // 如果是招标人意见
              if (j.value == "tenderOpinion") {
                // 不可编辑
                j.disabled = true;
              }
            });
          }
        });
      }
    },
    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (this.form.tenderOpinion != "" && this.form.tenderOpinion != null) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.form.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data =
        this.form.prjName +
        this.form.prequalificationStartDate +
        this.form.publishFlag;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },
    /**
     * 资格预审合格通知书的路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "资格预审结果通知书模板"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 图片压缩.zip的路径
          this.fileUrl = data;
        }
      });
    },
    /**
     * 资格预审结果通知书的路径
     * @author shuhua
     */
    fun_GetResultFileUrll() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "资格预审合格通知书模板"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 图片压缩.zip的路径
          this.resultFileUrl = data;
        }
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
